import BossModeBadge from './BossModeBadge.component';

export default BossModeBadge;
